import { render, staticRenderFns } from "./WarningsModal.vue?vue&type=template&id=24300203&scoped=true"
import script from "./WarningsModal.vue?vue&type=script&lang=js"
export * from "./WarningsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24300203",
  null
  
)

/* custom blocks */
import block0 from "./WarningsModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports